import React from 'react';
import PropTypes from 'prop-types';
import { GlobalNotifications, Intent, MobileModal } from '../../../Modules';
import Formsy from 'formsy-react';
import PaymentPlanFields from './PaymentPlanFields';

export default class PaymentPlanEditDesktop extends React.Component {
  static propTypes = {
    invoice: PropTypes.object.isRequired,
    localInvoice: PropTypes.object.isRequired,
    commitUpdate: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    open: PropTypes.bool,
    closeHandler: PropTypes.func.isRequired,
    closeEditor: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      submitted: false
    };
    this.reset = this.reset.bind(this);
    this.onValidSubmit = this.onValidSubmit.bind(this);
    this.onInvalidSubmit = this.onInvalidSubmit.bind(this);
    this.getRemainingBalance = this.getRemainingBalance.bind(this);
    this.getDownPayment = this.getDownPayment.bind(this);
    this.getAdditionalPayments = this.getAdditionalPayments.bind(this);
    this.sumOfIPPlanItems = this.sumOfIPPlanItems.bind(this);
  }

  componentWillUnmount() {
    if (this.props.closeEditor) this.props.closeEditor();
  }

  onValidSubmit() {
    this.setState({ submitted: true });
    if (this.getRemainingBalance() === 0) {
      this.props.commitUpdate(() => this.props.closeHandler());
    } else {
      GlobalNotifications.show({
        message: 'Unable to update payment plan',
        intent: Intent.DANGER
      });
    }
  }

  onInvalidSubmit() {
    this.setState({ submitted: true });
    GlobalNotifications.show({
      message: 'Unable to update payment plan',
      intent: Intent.DANGER
    });
  }

  getDownPayment() {
    const { localInvoice } = this.props;
    return localInvoice.down_payment_distribution_type === 'FIXED'
        ? localInvoice.down_payment_cents || 0
        : (localInvoice.total_cents || 0) *
          localInvoice.down_payment_percent /
          100;
  }

  getAdditionalPayments() {
    const { localInvoice } = this.props;
    return this.sumOfIPPlanItems(
      localInvoice.i_pplan_items.edges,
      'amount_cents'
    );
  }

  getRemainingBalance() {
    const { localInvoice } = this.props;
    return (
      localInvoice.total_cents - this.getDownPayment() - this.getAdditionalPayments()
    );
  }

  sumOfIPPlanItems(items, field) {
    return items.reduce((sum, item) => sum + (item.node[field] || 0), 0);
  }

  reset() {
    this.props.reset();
    setTimeout(() => this.props.closeHandler(), 0);
  }

  render() {
    return (
      <Formsy.Form
        onValidSubmit={this.onValidSubmit}
        onInvalidSubmit={this.onInvalidSubmit}
        ref='form'
      >
        <MobileModal
          open={this.props.open}
          onClose={this.props.closeHandler}
          inline
        >
          <MobileModal.Header>
            <div className='menu'>
              <a className='item' onClick={this.reset}>
                Cancel
              </a>
            </div>
            <div className='right menu'>
              <a className='item' onClick={() => this.refs.form.submit()}>
                Save
              </a>
            </div>
          </MobileModal.Header>
          <MobileModal.Content>
            <PaymentPlanFields
              invoice={this.props.invoice}
              localInvoice={this.props.localInvoice}
              onChange={this.props.onChange}
              getDownPayment={this.getDownPayment}
              getAdditionalPayments={this.getAdditionalPayments}
              getRemainingBalance={this.getRemainingBalance}
              submitted={this.state.submitted}
            />
          </MobileModal.Content>
        </MobileModal>
      </Formsy.Form>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/PaymentPlan/PaymentPlanEditMobile.js